module.exports = __webpack_public_path__ + "img/colaborador-mariana-emilio.83021103.png";